export default "__VITE_ASSET__DJCpKIUo__"